import { render, staticRenderFns } from "./Update-Account-Form.vue?vue&type=template&id=1250a064&scoped=true&"
import script from "./Update-Account-Form.vue?vue&type=script&lang=js&"
export * from "./Update-Account-Form.vue?vue&type=script&lang=js&"
import style0 from "./Update-Account-Form.vue?vue&type=style&index=0&id=1250a064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1250a064",
  null
  
)

export default component.exports